import styled from 'styled-components'

import { ButtonStyleProps, buttonStyles } from '../button.styles'

export const ButtonLinkStyled = styled('a').withConfig({
  shouldForwardProp: (prop) => !['buttonTheme', 'buttonHeight', 'minWidth'].includes(prop)
})<ButtonStyleProps>`
  ${buttonStyles};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
